import styled from 'styled-components';
import {
  background,
  border,
  color,
  layout,
  position,
  shadow,
  space,
  typography,
} from 'styled-system';

import { getCursorType, textEllipses } from '../utils';

export const Box = styled.div`
  width: inherit;
  white-space: ${({ nowrap }) => (nowrap ? 'nowrap' : '')};

  ${color}
  ${border}
  ${typography}
  ${layout}
  ${space}
  ${shadow}
  ${background}
  ${position}

  ${getCursorType}
  ${textEllipses}
`;
